var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    enableBackground: "new 0 0 39 39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 39,
    height: 39,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnBAMAAAB+jUwGAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAALVBMVEX/////V3r/V3r/V3r/ V3r/V3r/V3r/V3r/V3r/V3r/V3r/V3r/V3r/V3r///9bsO4OAAAADXRSTlMAYNDwgBCgwEBQsJAg iiuP9QAAAAFiS0dEAIgFHUgAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAHdElNRQflCwQOHAnn2k4k AAAAXUlEQVQoz2NgELqLCi67MjCw3UUHlwIYZDEE7xYw6GIKXmC4e1ejAwXkggUbGFAA76jgqCC5 ghNQBWPBgiYuKEAXKLgWM30aMPRiCjowMNqii90GGnykHBVUNzAAAPmr/OArKtjoAAAAJXRFWHRk YXRlOmNyZWF0ZQAyMDIxLTExLTA0VDE0OjI4OjA5KzAwOjAw/pXCrQAAACV0RVh0ZGF0ZTptb2Rp ZnkAMjAyMS0xMS0wNFQxNDoyODowOSswMDowMI/IehEAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/Stop.4f1ff86afc92468c2a2c677865e78f60.svg";
export { ForwardRef as ReactComponent };